import { Project, ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add `descriptionsByIri` to the model data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v14 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v14Projects(prevState.projects);
  }

  return nextState;
};

const v14Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const modelsById = { ...project.modelsById };
    const updatedModelsById = Object.values(modelsById).reduce<
      Record<string, ProjectModel>
    >((acc, model) => {
      const updatedModel: ProjectModel = { ...model, descriptionsByIri: {} };
      acc[updatedModel.id] = updatedModel;
      return acc;
    }, {});

    projectsById[projectId] = {
      ...project,
      modelsById: updatedModelsById,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            descriptionsByIri: {},
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
